/* @flow */

module.exports = {
  "APP": {
    "NAME": "Qstar shop",
  },
  "LOCALE": {
    "CURRENCY": "SEK",
    "CURRENCY_SHORT": "kr",
    "POINTS": "poäng",
  },
  "SKIP_TO_CONTENT": "Gå till innehåll",
  "META": {
    "HELPDESK_LINK": "https://helpdesk.crossroads.se/?s=7740d6c3aa4cf269c9a32a49a75f9a0a",
  },
  "URL": {
    "CHECKOUT_CART": "/checkout/cart",
    "CHECKOUT_OVERVIEW": "/checkout/overview",
    "CHECKOUT_FAILED": "/checkout/overview",
    "CHECKOUT_SUCCESS": "/checkout/success",
    "ABOUT": "/om-oss",
  },
  "LOGO": {
    "ALT": "Qstar",
    "TITLE": "Gå till startsidan",
  },
  "CLOSE_SYSTEM_MESSAGE": "Stäng meddelande",
  "COOKIE_CONSENT": {
    "ALL": "Tillåt alla",
    "SELECTED": "Tillåt urval",
    "NECESSARY": "Tillåt nödvändiga",
  },
  "COOKIE_OPTIONS": {
    "NECESSARY": "Nödvändiga",
    "STATISTICAL": "Statistiska",
    "MARKETING": "Marknadsföring",
  },
  "CURRENCY_SHORT": {
    "NOK": "kr",
    "DKK": "kr",
    "SEK": "kr",
    "EUR": "€",
  },
  "BREADCRUMBS": {
    "HOME": "Hem",
    "HOME_URL": "/",
    "SEARCH_RESULTS_FOR": "Sökresultat för: ",
  },
  "COMMON": {
    "SEE_PRICE": "Se pris!",
  },
  "HOMEVIEW": {
    "POPULAR_CATEGORIES": "Populära kategorier",
    "ALL_CATEGORIES": "Till alla kategorier",
    "MORE_POPULAR_PRODUCTS": "Fler populära produkter",
    "OFFERINGS": "Erbjudanden",
  },
  "ALL_PRODUCTS": {
    "TITLE": "Produkter",
  },
  "PRODUCTLIST_HERO": {
    "TITLE_PREFIX_EMPTY": "Inga produkter att visa",
    "TITLE_PREFIX_SINGULAR": "Visar 1 produkt inom <span>%title</span>",
    "TITLE_PREFIX_PLURAL": "Visar %itemsCount produkter inom <span>%title</span>",
    "IN_PRICERANGE": "i prisintervallet",
  },
  "SORT": {
    "OFFCANVAS": {
      "TITLE": "Sortera",
      "SHOW_RESULT": "Visa resultat",
      "CLOSE_MENU": "Stäng sorterings menyn",
    },
  },
  "FILTER": {
    "FILTERBAR": {
      "ALL_FILTERS": "Filtrera",
      "FILTER_BY_POINTS": "Filtrera på poäng",
      "FILTER_BY_PRICE": "Filtrera på pris",
      "PRICE_RANGE_MIN": "%min kr",
      "PRICE_RANGE_MAX": "%max kr",
      "SORT": "Sortera",
      "SORT_DEFAULT": "Utvalda",
      "SORT_NAME_DOWN": "Produktnamn: Ö-A",
      "SORT_NAME_UP": "Produktnamn: A-Ö",
      "SORT_PRICE_DOWN": "Dyrast",
      "SORT_PRICE_UP": "Billigast",
      "SORT_POSITION_DOWN": "Populärast",
      "SORT_POPULAR_DOWN": "Populärast",
      "SORT_VALUE_DOWN": "Värde: Lågt",
      "SORT_VALUE_UP": "Värde: Högt",
      "SORT_RELEASE_DATE_DOWN": "Senaste",
      "SORT_RELEASE_DATE_UP": "Äldst",
      "SORT_LATEST_DOWN": "Senaste",
      "SORT_MANUFACTURER_DOWN": "Varumärke: A-Ö",
      "SORT_MANUFACTURER_UP": "Varumärke: Ö-A",
      "SORT_RELEVANCE_DOWN": "Mest relevant",
      "SORT_RELEVANCE_UP": "Minst relevant",
      "RANGESLIDER": "Skjutreglage",
    },
    "OFFCANVAS": {
      "TITLE": "Filter",
      "SHOW_RESULT_TOTAL_SINGLE": "%total Produkt",
      "SHOW_RESULT_TOTAL_MULTIPLE": "%total Produkter",
      "SHOW_RESULT": "Visa resultat",
      "CLOSE_MENU": "Stäng filter menyn",
    },
    "ACTIVE_FILTERS": {
      "CLEAR_ALL": "Rensa filter",
      "NO_ACTIVE_FILTERS": "Du har inga aktiva filter",
      "PRICE_RANGE": "Pris (%range)",
      "TOTAL_COUNT": "Visar %count produkter",
      "REMOVE": "Ta bort filter",
    },
    "FILTERMENU": {
      "FILTER_BY_POINTS": "Filtrera på poäng",
      "FILTER_BY_PRICE": "Filtrera på pris",
      "RESET_PRICE": "Rensa filter",
      "PRICE_FROM": "Från",
      "PRICE_TO": "Till",
      "BALANCE_FILTER": "Filtrera på saldo (%value poäng)",
      "WITHIN_BALANCE": "Produkter inom poängsaldo",
    },
  },
  "ADDRESS": {
    "FIRSTNAME": "Förnamn",
    "LASTNAME": "Efternamn",
    "STREET_1": "Gatuadress 1",
    "STREET_2": "Gatuadress 2 (frivilligt)",
    "POSTCODE": "Postnummer",
    "CITY": "Stad",
    "COUNTRY": "Land",
    "EMAIL": "E-mail",
    "TELEPHONE": "Telefon",
  },
  "CAROUSEL": {
    "ITEM_LABEL": "Artikel %current av %total",
    "CONTROLS": {
      "PREV_ITEM_GROUP_LABEL": "Föregående artikelgrupp",
      "NEXT_ITEM_GROUP_LABEL": "Nästa artikelgrupp",
      "GO_TO_ITEM_GROUP_LABEL": "Gå till artikelgrupp %number",
      "PLAY_LABEL": "Starta automatisk uppspelning",
      "PAUSE_LABEL": "Pausa automatisk uppspelning",
    },
  },
  "OR": "eller",
  "CART": {
    "HEADING": "Varukorg",
    "TOTALS": "Totalt",
    "EMPTY": "Varukorgen är tom",
    "CTA": "Gå till varukorgen",
    "NAV_BUTTON_OPEN": "Öppna varukorgen - %count produkt(er)",
    "NAV_BUTTON_CLOSE": "Stäng varukorgen - %count produkt(er)",
    "NAV_BUTTON_CART": "Gå till varukorgen - %count produkt(er)",
    "ALT": "Ändra i varukorg",
    "INCREMENT": "Öka kvantitet",
    "DECREMENT": "Minska kvantitet",
    "QUANTITY": "Kvantitet",
    "SHIPPING": "Frakt",
    "SUBTOTAL": "Summa",
    "GRANDTOTAL": "Totalsumma inkl moms",
    "SUMMARY": "Summering",
    "TO_CHECKOUT": "Gå till kassan",
    "DIALOG_CANCEL": "Avbryt",
    "REMOVE_PRODUCT": "Ta bort produkt",
    "REMOVE_APPROVE": "Ja, ta bort",
    "CONFIRM_TEXT": "Vill du verkligen ta bort '%itemName' från varukorgen?",
    "DISCOUNT": "Rabatt",
    "CONTINUE_SHOPPING": "Fortsätt handla",
    "SUB_TOTAL": "Summa",
    "GRAND_TOTAL": "Totalt att betala",
    "CLOSE": "Stäng varukorgen",
    "CLOSE_SUMMARY": "Stäng summeringen",
    "OPEN_SUMMARY": "Öppna summeringen",
    "SUBMIT": "Spara antal produkter",
  },
  "DIALOGUE": {
    "CLOSE": "Stäng dialog",
  },
  "NOTIFICATIONBAR": {
    "CLOSE": "Stäng banner",
  },
  "CHECKOUT": {
    "TITLE": "Kassa",
    "CONTINUE": "Fortsätt",
    "TO_PAYMENT": "Gå till betalning",
    "AMOUNT_TO_PAY": "Att betala",
    "EDIT": "Ändra",
    "COMPLETE_PURCHASE": "Slutför köp",
    "BACK_TO_CART_TEXT": "Tillbaka till varukorgen",
    "I_ACCEPT_THE": "Jag accepterar",
    "TERMS": "köpvillkoren",
    "TERMS_URL": "villkor",
    "TERMS_CLOSE": "Stäng villkor",
    "PAYMENT_METHOD_STEP": "Välj betalningsmetod",
    "PAY_STEP": "Gå till säker betalning",
    "VIRTUAL_TERMS": "Jag samtycker till att det digitala presentkortet levereras omedelbart och är medveten om att detta innebär att jag inte längre har ångerrätt.",
    "DISCOUNT_CODE": {
      "HEADER": "Rabattkod",
      "PLACEHOLDER": "Ange kod",
      "APPLY": "Använd",
      "REMOVE": "Ta bort",
    },
    "ADDRESS": {
      "ADDRESS": "Faktura & leveransinformation",
      "SHIPPING": "Leveransadress",
      "SHIP_TO_SAME_ADDRESS": "Leverera till samma adress",
    },
    "OPT_EMAIL": "Jag vill signa upp mig på nyhetsbrev och få 30% rabatt på nästa köp",
    "EXTRA_INFO": "Awardit CLS AB, org.nr 556578-1571, är exklusiv avtalspart och ansvarig leverantör för denna order.",
  },
  "PAYMENT_METHODS": {
    "ALTAPAY": {
      "CARD": "Betala med kort",
    },
  },
  "CUSTOMER_SERVICE": {
    "TEXT": "Kundservice",
    "LINK": "/kundservice",
  },
  "SUCCESS": {
    "TITLE": "Beställning registrerad",
    "SUB_TITLE": "Ordernummer %number",
    "NOT_FOUND_TITLE": "Ingen order hittades.",
    "NOT_FOUND_SUBTITLE": "Vänligen kontakta kundtjänst om detta är felaktigt.",
    "BACK": "Återgå till shoppen",
    "VALID_UNTIL": "Giltig t.o.m. %date",
    "WHAT_NOW": "Så vad händer nu?",
    "ORDER_OVERVIEW": "Orderöversikt",
    "CONTACT": {
      "TITLE": "Kontakta oss",
      "CREATE_TICKET": "Skapa ärende",
      "INFO": "Du kan skapa ärende när som helst.</br>Vi svarar vanligtvis inom 1-2 arbetsdagar.",
      "OR": "eller",
      "REGRET_PURCHASE": "Ångra mitt köp",
      "CALL_US": "Ring oss",
      "CALL_US_HOURS": "Öppettider:<br />mån-fre: 10.00-12.00, lör-sön: Stängt",
      "CALL_US_PHONENUMBER": "+46 (0)31 700 83 81",
    },
    "STEPS": {
      "NORMAL": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse kommer att skickas till %email inom kort.",
        },
        "2": {
          "HEADING": "Bearbetning",
          "TEXT": "Din beställning skickas när samtliga produkter finns tillgängliga för leverans. Vanligen sker detta redan nästkommande dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e‑post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 1–2 dagar.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Vissa paket levereras direkt i din brevlåda. Paket som är för stora levereras i stället till ett utlämningsställe och aviseras via sms till det mobilnummer du har angivit i beställningen. Paket ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "MIXED": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "En orderbekräftelse och dina digitala biljetter/värdekoder kommer att skickas till %email inom kort. Har du inte fått någon e‑post ber vi dig dubbelkolla ditt spam-filter innan du kontaktar kundservice.",
        },
        "2": {
          "HEADING": "Bearbetning",
          "TEXT": "Din beställning skickas när samtliga produkter finns tillgängliga för leverans. Vanligen sker detta redan nästkommande dag.",
        },
        "3": {
          "HEADING": "Transport",
          "TEXT": "När dina varor packats och skickats så meddelas du via e‑post. I leveransbekräftelsen finner du en spårningslänk med vilken du kan följa paketets väg. Leveransen tar normalt 1–2 dagar.",
        },
        "4": {
          "HEADING": "Leverans",
          "TEXT": "Vi skickar dina digitala biljetter/värdekoder till %email inom kort. Din fysiska leverans skickas med DBSchenker. Vissa paket levereras direkt i din brevlåda. Paket som är för stora levereras i stället till ett utlämningsställe och aviseras via sms till det mobilnummer du har angivit i beställningen. Paket ligger kvar på utlämningsstället i 14 dagar.",
        },
      },
      "VIRTUAL": {
        "1": {
          "HEADING": "Bekräftelse",
          "TEXT": "Du kommer att få en orderbekräftelse till %email.",
        },
        "2": {
          "HEADING": "Digital leverans",
          "TEXT": "Vi skickar dina digitala biljetter/värdekoder till %email inom kort. Har du inte fått någon e‑post ber vi dig dubbelkolla ditt spam-filter innan du kontaktar kundservice.",
        },
      },
    },
  },
  "PRODUCTLIST": {
    "EMPTY": "Det finns inga produkter att visa just nu",
  },
  "CATEGORY": {
    "SEE_ALL_IN_MAIN_CATEGORY": "Se alla i %mainCategory",
  },
  "POPULAR": {
    "POPULAR_PRODUCTS": "Populära produkter",
  },
  "404": {
    "TITLE": "Sidan kunde inte hittas",
    "HEADING": "— 404 —",
    "SUBHEADING": "Sidan kunde inte hittas",
  },
  "SERVER_ERROR": {
    "TITLE": "Serverfel",
    "TEXT": "<strong>Behöver du kontakta oss?</strong><br/> Skicka ett mail till <a href=\"mailto:kundservice@crossroads.se\">kundservice@crossroads.se</a>",
  },
  "SEARCH": {
    "TITLE_PREFIX": "Sök: ",
    "PLACEHOLDER": "Sök i sortimentet",
    "RESULTS": "Resultat för sökningen \"%query\"",
    "TYPE": {
      "CATEGORY": "Kategori",
      "PRODUCT": "Produkt",
      "BRAND": "Varumärke",
    },
    "OPEN": "Öppna sökmenyn",
    "CLOSE": "Stäng sökmenyn",
    "PRODUCTS_IN_SEARCH_RESULT": "Hittade %itemsCount produkter som matchade",
    "PRODUCT_IN_SEARCH_RESULT": "Hittade en produkt som matchade",
    "EMPTY": "Det finns inga produkter att visa just nu",
  },
  "ICONS": {
    "CHEVRON": "Pil",
    "CROSS": "Kryss",
    "SEARCH": "Förstoringsglas",
    "HAMBURGER": "Tre horisontella streck (hamburgarikon)",
    "CUSTOMER_SERVICE": "Headset med mikrofon",
    "CART": "Kundvagn",
    "CHECK": "Bock",
    "CHAT": "Pratbubbla",
    "PHONE": "Telefon",
  },
  "HEADER": {
    "MAIN_NAVIGATION": "Huvudmeny",
    "SEARCH": "Sök",
    "CATEGORIES": "Kategorier",
    "BRANDS": "Varumärken",
    "ABOUT": "Om oss",
    "CART": "Kassan",
    "OPEN_MENU": "Öppna menyn",
    "CLOSE_MENU": "Stäng menyn",
    "GO_BACK": "Gå tillbaka",
  },
  "DRAWER": {
    "OPEN_SUBMENU": "Öppna undermeny",
    "CLOSE_SUBMENU": "Stäng undermeny",
  },
  "FOOTER": {
    "LINKS": {
      "NAVIGATION": "Sidfotsmeny",
      "TITLE": "Länkar",
      "START": "Hem",
      "CATEGORIES": "Kategorier",
      "BRANDS": "Varumärken",
      "SEARCH": "Sök i sortimentet",
    },
    "NEED_HELP": {
      "TITLE": "Behöver du hjälp?",
      "CONTACT": "Kontakta oss",
    },
    "TERMS": "Villkor",
    "PRIVACY_POLICY": "Integritetspolicy",
    "COOKIES": "Hantera cookies",
    "ACCESSIBILITY": "Tillgänglighet",
    "COPYRIGHT": "Copyright © %year <a href=\"https://www.awardit.com/\" target=\"_blank\" rel=\"noopener\">Qstar webshop drivs av Awardit CLS AB</a>",
  },
  "PRODUCT": {
    "ADD_TO_CART": "Lägg i varukorg",
    "OUT_OF_STOCK": "Ej i lager",
    "RELATED_PRODUCTS": "Relaterade produkter",
    "CROSS_SELL_PRODUCTS": "Andra gillade också",
    "OPTION_DROPDOWN_PLACEHOLDER": "Välj ett val",
    "DISCOUNT": "%discount%",
    "CHANGE_IMAGE": "Byt bild",
    "GO_TO_MANUFACTURER": "Se alla produkter från %brand",
    "ABOUT_BRAND": "Om %brand",
    "COLOR": "Färg:",
    "CHOOSE_A_COLOR": "Välj en färg",
    "DESCRIPTION": "Produktbeskrivning",
    "MSRP": "Rek. pris",
    "SHOP_PRICE": "Shoppris",
  },
  "FREE_SHIPPING": {
    "PROGRESS": "%value kr till gratis frakt",
    "COMPLETED": "Gratis frakt",
  },
  "PROGRESS_BAR": {
    "PROGRESS": "Framsteg: %percent%",
  },
  "VALIDATION": {
    "REQUIRED": "Obligatoriskt fält",
    "EMAIL": "Vänligen fyll i en korrekt e‑postadress",
    "PHONE": "Vänligen fyll i ett korrekt mobiltelefonnummer",
    "NUMERIC": "Fältet får bara innehålla nummer",
    "LENGTH_LT": "Fältet innehåller för många tecken",
    "POSTCODE": "Vänligen fyll i ett korrekt postnummer (XXX XX)",
    "MISSING_FIELD": "Adress saknas, försök igen",
  },
  "PRICE_LOCK": {
    "HEADER": "Fyll i din e-post för att se priser och erbjudanden!",
    "TERMS_TEXT": "Jag samtycker till att Qstar får använda de uppgifter som jag lämnar nedan för att kontakta mig angående Qstars tjänster och produkter. Jag bekräftar även att jag tagit del av Qstar <a href=\"/privacy-policy\" target=\"_blank\">integritetspolicy</a> samt att jag när som helst kan återkalla samtycket.",
    "CLOSE": "Stäng",
    "SEND": "Skicka",
  },
  "STATUS_CODE": {
    "UNKNOWN": "Ett okänt fel har uppstått. Vänligen ladda om sidan och försök igen.",
    "NETWORK_ERROR": "Anropet avbröts. Vänligen verifiera att du har en aktiv internetanslutning eller försök igen om en stund.",
    "PLACE_ORDER_CATCH": "Ett fel uppstod. Vänligen försök igen senare.",
    "AQUIRER_DECLINE": "Betalningen har nekats. Vänligen verifiera dina kort-/kontouppgifter.",
    "DISCOUNT_CODE_APPLIED": "Rabattkod applicerad.",
    "DISCOUNT_CODE_FAILURE": "Rabattkoden kunde inte appliceras, vänligt försök igen eller kontakta kundtjänst.",
    "DISCOUNT_CODE_REMOVE_FAILURE": "Rabattkoden kunde inte tas bort, vänligt försök igen eller kontakta kundtjänst.",
    "errorUnknownProduct": "Okänd produkt, vänligen försök igen.",
    "errorNoPaymentMethod": "Ingen betalmetod vald.",

    "errorFraudShop": "Det är inte möjligt att slutföra ett köp just nu",
    "errorFraudOrder": "Köpet är inte tillåtet. Kontakta support för mer information",
    "errorFraudProduct": "Gränsen har nåtts för en eller flera produkter i varukorgen. Kontakta support för mer information.",
    "errorFraudBlacklist": "Köpet är inte tillåtet. Kontakta support för mer information.",
    "errorDeclinedCard": "Kortet nekades.",

    "errorProductQuantityNotAvailable": "Det antal du angav finns inte tillgängligt just nu.",
    "errorProductNotInStock": "Produkten du försökte lägga i varukorgen finns dessvärre inte i lager just nu.",
    "errorProductMaxQuantity": "Det angivna antalet finns dessvärre inte i lager just nu.",
    "errorProductNotChosenVariant": "Vänligen välj %attributeLabel för att kunna lägga till produkten i din varukorg.",
    "errorProductsNotAvailable": "Alla produkter i varukorgen finns dessvärre inte i lager just nu.",
    "errorBlacklistedEmail": "Emailadressen du angav används redan av ett annat konto. Vänligen ange en annan.",
    "errorEmailExists": "Emailadressen du angav används redan av ett annat konto. Vänligen ange en annan.",
    "errorInvalidTelephone": "Ogiltigt telefonnummerformat.",
    "INTERNAL_SERVER_ERROR": "Internt serverfel.",
    "errorMaxAttemptsReached": "För många anrop. Vänligen vänta några minuter och prova igen.",
    "ITEM_REMOVED_FROM_CART": "%name togs bort från varukorgen eftersom att den inte längre finns i lager.",
    "NEWSLETTER": {
      "SUCCESS": "Epost registrerad. Välkommen till Qstar shop!",
      "ERROR": {
        "notModified": "Kunde inte lägga till e-post. Det är möjligt att e-postadressen redan används.",
        "invalidEmail": "Den angivna e-postadressen är ogiltig.",
        "notLoggedIn": "Var vänlig ange en giltig e-postadress. E-postfältet kan inte lämnas tomt.",
      },
    },
  },
};
